'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

import getUrlParameter from '@function/getUrlParameter'

const { app, moment, qwest } = window;

moment.locale('fr');

const base_video_url = 'https://www.youtube-nocookie.com/embed/';

export default class TutorialPage extends Component
{
	state =
	{
		tutorial: { },
		loading: true
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		qwest.post('/CMS/getAll',
		{
			model: 'Tutorial'.toLowerCase(),
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				tutorial: response.data[0] || { },
				references: response.references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />
		)
		: undefined;

		const date = moment(state.tutorial.date).format('dddd DD MMMM');

		let title = state.tutorial?.title
		? state.tutorial.title
		: 'Tutoriel du ' + date;

		let video_id = state.tutorial?.youtube
		? getUrlParameter('v', state.tutorial.youtube)
		: undefined;

		const video = video_id ?
		(
			<iframe className="c-model__video" width="560" height="315"
			src={ base_video_url + video_id + '?rel=0' }
			title="YouTube video player"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
		)
		: undefined;

		let output =
		(
			<Layout history={ props.history } page_title={ title } hide_title={ true }>

				<div className="page-content c-model c-model--tutorial">

					<HolidaysMessage />

					<div className="c-model__wrapper">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								{ title }
							</h2>
						</div>

						<div className="c-model__body">

							<div className="c-model__video-container">
								{ video }
							</div>

						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
